import React from "react";
import {
  NavBarLink,
  NavBarWrapper,
  Span,
  PersonalDetailsWrapper,
  PrimaryButtonLink
} from "../../UIKit/styles";

export default function Navigation({
  navLinks = [],
  userDetails: {given_name = "", family_name =""},
  signOut,
  setShowDisclaimer,
  pathname
}) {
  return (
    <NavBarWrapper>
      <PersonalDetailsWrapper  data-testid="personal-details-wrapper">
        <Span>
          Signed in as, {given_name} {family_name}
        </Span>
        <PrimaryButtonLink
          
          onClick={() => {
            setShowDisclaimer(true);
            signOut();
          }}
          data-testid="sign-out-button"
        >
          Sign out
        </PrimaryButtonLink>

      </PersonalDetailsWrapper>

      {pathname !== "/" &&
        pathname !== "/summary" &&
        navLinks.map(({ path, title, disabled, renewOrchardData, setRenewOrchardData }) => (
          <NavBarLink to={path} disabled={disabled} key={path} onClick={()=>{
            console.log('clicked a nav link', path, renewOrchardData)
            if (renewOrchardData) {
              setRenewOrchardData(renewOrchardData);
            }
          }}>
            <Span>{title}</Span>
          </NavBarLink>
        ))}
    </NavBarWrapper>
  );
}
